export default {
  placeholder: 'Escreva sua anotação...',
  insert: 'Inserir Texto',
  label: {
    link: 'Link',
  },
  button: {
    confirm: 'Confirmar',
  },
};
